<template>
  <form-page-template
    :dirty="dirty"
    @save="doSave"
    show-apply-button>
    <template #toolbar-items>
      <v-toolbar-title class="with-divider">
        事業者管理
      </v-toolbar-title>
    </template>

    <owner-form
      v-model="ownerForm"
      @dirty="markDirty"
      v-if="ownerForm">
    </owner-form>
  </form-page-template>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import IoablePageMixin from "@/router/IoablePageMixin";
import FormPageTemplate from "@/components/templates/FormPageTemplate.vue";
import OwnerForm from "@/components/pages/admin/OwnerShow/OwnerForm.vue";

export default {
  name: 'OwnerShow',
  mixins: [
    IoablePageMixin
  ],
  components: {
    FormPageTemplate,
    OwnerForm
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account'
    }),
  },
  data() {
    return {
      ownerForm: null
    }
  },
  methods: {
    ...mapActions({
      fetchLoginOwner: 'hcs/fetchLoginOwner',
      updateOwner: 'hcs/updateOwner'
    }),
    load() {
      return this
          .fetchLoginOwner()
          .then(owner => {
            this.ownerForm = {...owner};
          });
    },
    save() {
      return this
          .updateOwner(this.ownerForm)
          .then(owner => {
            this.ownerForm = {...owner};
          });
    }
  },
}
</script>
